import CommentModel from '../Apis/Comment'
import Controller from './Controller'

export default class CommentController extends Controller {
  constructor() {
    super(new CommentModel())
  }
}
